import {
  MotifAccordion,
  MotifAccordionContent,
  MotifAccordionTrigger,
  MotifTruncate,
} from "@ey-xd/motif-react";
import "./Accordian.scss";
import { SKU } from "../../../../store/slices/CheckoutSlice";
import { calculateTotalCost } from "../../CheckoutHelper";

interface AccordianProps {
  skuDetails: SKU[];
  productName: string;
}
export function Accordian({ skuDetails, productName }: AccordianProps) {
  const getTotalOrderAmount = (SkuDetails: any) => {
    if (!SkuDetails || SkuDetails === null) {
      return 0;
    }
    if (SkuDetails && SkuDetails !== null) {
      let totalAmount = 0;
      SkuDetails.forEach((sku: any) => {
        if (
          !sku?.OrderQuantity ||
          !sku?.CostMetricCost ||
          !sku?.OrderInterval
        ) {
          return 0;
        }
        const quantity = sku?.OrderQuantity || 0;
        const cost = sku?.CostMetricCost || 0;
        const duration = sku?.OrderInterval || 0;
        totalAmount += cost * quantity * duration;
        if (sku?.SkuRelation && sku?.SkuRelation?.length > 0) {
          sku?.SkuRelation.forEach((relation: any) => {
            const quantity = relation.OrderQuantity || 0;
            const cost = relation.CostMetricCost || 0;
            const duration = relation.OrderInterval || 0;
            totalAmount += cost * quantity * duration;
          });
        }
      });
      return totalAmount.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    }
  };

  if (!skuDetails || skuDetails?.length === 0) {
    return <div>No SKUs available</div>;
  }
  let totalQuantity = 0;
  skuDetails.forEach((sku) => {
    if (sku?.OrderQuantity) {
      totalQuantity += sku?.OrderQuantity;
    }
    if (sku?.SkuRelation && sku?.SkuRelation?.length > 0) {
      sku?.SkuRelation.forEach((relation) => {
        if (relation.OrderQuantity) {
          totalQuantity += relation.OrderQuantity;
        }
      });
    }
  });
  return (
    <>
      <div
        style={{
          alignItems: "flex-start",
          display: "flex",
          flexWrap: "wrap",
          gap: "15px",
          padding: "10px 0 20 10px",
        }}
      >
        <div
          style={{
            flex: "1",
          }}
        >
          <MotifAccordion
            variant="functional"
            useChevronIcon={true}
            className="accordian-wrapper"
          >
            <MotifAccordionTrigger>
              <div className="sku-wrapper">
                <div className="sku-title">
                  {
                    <MotifTruncate maxLines={2} maxWidth={80}>
                      {productName}
                    </MotifTruncate>
                  }
                  <span> x {totalQuantity}</span>
                </div>
                <div className="amount">{getTotalOrderAmount(skuDetails)}</div>
              </div>
            </MotifAccordionTrigger>
            <MotifAccordionContent>
              {skuDetails.map((sku, index) => (
                <>
                  <div key={index} className="sku-wrapper child-wrapper">
                    <div className="sku-title">
                      {sku?.Name} (
                      {`${
                        sku.CostIntervalCd === "onetime"
                          ? ""
                          : sku.OrderInterval
                      } ${sku?.CostIntervalCd}`}
                      )
                    </div>
                    <div className="amount">{calculateTotalCost(sku)}</div>
                  </div>
                  {sku?.SkuRelation && sku?.SkuRelation?.length > 0
                    ? sku?.SkuRelation.map((relation, relationIndex) => (
                        <div
                          key={`${index}-${relationIndex}`}
                          className="sku-wrapper child-wrapper"
                        >
                          <div className="sku-title">
                            {relation.Name} (
                            {`${
                              relation.CostIntervalCd === "onetime"
                                ? ""
                                : relation.OrderInterval
                            } ${relation.CostIntervalCd}`}
                            )
                          </div>
                          <div className="amount">
                            {calculateTotalCost(relation)}
                          </div>
                        </div>
                      ))
                    : null}
                </>
              ))}
            </MotifAccordionContent>
          </MotifAccordion>
        </div>
      </div>
    </>
  );
}
